import { render } from "./FormBlockComponent.vue?vue&type=template&id=79e1fb2d&scoped=true"
import script from "./FormBlockComponent.vue?vue&type=script&lang=js"
export * from "./FormBlockComponent.vue?vue&type=script&lang=js"

import "./FormBlockComponent.vue?vue&type=style&index=0&id=79e1fb2d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e1fb2d"]])

export default __exports__